import { render, staticRenderFns } from "./Fake.vue?vue&type=template&id=dad0780e"
import script from "./Fake.vue?vue&type=script&lang=js"
export * from "./Fake.vue?vue&type=script&lang=js"
import style0 from "./Fake.vue?vue&type=style&index=0&id=dad0780e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports